import React, {useEffect, useRef, useState} from "react";
import "./UnionStyleSheet.css"
import {Box, TextField} from "@material-ui/core";
import CustomTable from "../../component/customTable/CustomTable";
import {Pagination} from "@material-ui/lab";
import {convertCurrencyFormatPositiveNegative, convertToBirthDate} from "../../utils/numberConvertor";
import DefaultDialogPage from "../../component/defaultDialogPage/DefaultDialogPage";
import {useAuthState} from "../../context/AuthContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {UnionService} from "./UnionService";
import {convertUniversalDateToPersianDate} from "../../utils/TimeConvertor";
import useDraggableScroll from "use-draggable-scroll";

let page = 0
const pageSize = 15
const UnionDetailPage = () => {

    const {token, fundID} = useAuthState()
    const snackbar = useSnackbarDispatcher()
    const loading = useLoadingDispatcher()

    const service = new UnionService(token, snackbar, loading, fundID)

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const [unionInfoList, setUnionInfoList] = useState([]);

    const [pageCount, setPageCount] = useState(0);
    const [transactionSummation, setTransactionSummation] = useState(0);

    const [investmentMonths, setInvestmentMonths] = useState("");
    const [totalCashBalance, setTotalCashBalance] = useState("");
    const [totalUnionBalance, setTotalUnionBalance] = useState("");
    const [unionAverageBalance, setUnionAverageBalance] = useState("");
    const [totalBalance, setTotalBalance] = useState("");


    //drag-start
    const ref = useRef(null);
    const {onMouseDown} = useDraggableScroll(ref, {direction: 'vertical'});
    //drag-end

    useEffect(() => {
        if (typeof fundID !== "undefined") {
            getFundUnionDetailFromServer()
        }
    }, [fundID])

    function getFundUnionDetailFromServer() {
        loading(setLoadingStateDispatch(true))
        page = 0
        service.getFundUnionInfo(pageSize)
            .then(response => {
                loading(setLoadingStateDispatch(false))

                setUnionInfo(response.info)
                setUnionTransactionsInfo(response.transaction)

            }).catch(reason => {
            loading(setLoadingStateDispatch(false))
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در دریافت اطلاعات صندوق!"))
        })
    }

    function setUnionInfo(info) {
        setInvestmentMonths(info.investmentMonths)
        setTotalCashBalance(info.totalCashBalance)
        setTotalUnionBalance(info.totalUnionBalance)
        setUnionAverageBalance(info.unionAverageBalance)
        setTotalBalance(info.totalBalance)

    }

    function setUnionTransactionsInfo(transaction) {
        setPageCount(transaction.totalPage)
        setTransactionSummation(transaction.summationOfAmounts)

        setUnionInfoList([])

        transaction.data.map((item, index) => {
            setUnionInfoList(prevState => [
                ...prevState,
                {
                    id: item.id,
                    number: (page * pageSize) + index + 1,
                    amount: convertCurrencyFormatPositiveNegative(item.amount),
                    "date": convertUniversalDateToPersianDate(item.date),
                }
            ])
        })
    }

    function handleChangePagination(event, value) {
        page = value - 1
        getUnionTransactionsList()
    }

    function getUnionTransactionsList(
        startDateValue = startDate,
        endDateValue = endDate
    ) {
        loading(setLoadingStateDispatch(true))

        service.getFundTransactions(page, pageSize, startDateValue, endDateValue)
            .then(response => {
                setUnionTransactionsInfo(response)
                loading(setLoadingStateDispatch(false))
            }).catch(reason => {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در دریافت تراکنش های اتحادیه!"))
            loading(setLoadingStateDispatch(false))
        })
    }


    return (
        <>
            <div className={"unionDetailPageContainer"}>
                <div className={"unionDetailSmallReportContainer hideScroll"} ref={ref} onMouseDown={onMouseDown}>
                    <div className={"infoBoxContainer"}>
                        <span className={"fs-1"}>موجودی صندوق</span>
                        <span
                            className={"fs-3"}>{totalCashBalance ? convertCurrencyFormatPositiveNegative(totalCashBalance) : "0"} ریال</span>
                    </div>
                    <div className={"infoBoxContainer"}>
                        <span className={"fs-1"}>موجودی نقد صندوق</span>
                        <span
                            className={"fs-3"}>{totalBalance ? convertCurrencyFormatPositiveNegative(totalBalance) : "0"} ریال</span>
                    </div>
                    <div className={"infoBoxContainer"}>
                        <span className={"fs-1"}>ماه سرمایه گذاری</span>
                        <span className={"fs-3"}>{investmentMonths} ماه</span>
                    </div>
                    <div className={"infoBoxContainer"}>
                        <span className={"fs-1"}>مجموع سرمایه گذاری</span>
                        <span
                            className={"fs-3"}>{totalUnionBalance ? convertCurrencyFormatPositiveNegative(totalUnionBalance) : "0"} ریال</span>
                    </div>
                    <div className={"infoBoxContainer"}>
                        <span className={"fs-1"}>میانگین سرمایه گذاری</span>
                        <span
                            className={"fs-3"}>{unionAverageBalance ? convertCurrencyFormatPositiveNegative(unionAverageBalance) : "0"} ریال</span>
                    </div>
                </div>
                <div className={"unionDetailSearchInfo"}>
                    <TextField
                        className="w-100"
                        id="outlined-basic"
                        label="تاریخ شروع"
                        variant="outlined"
                        value={startDate}
                        onChange={e => {
                            let date = convertToBirthDate(e.target.value);

                            if (date.length === 0 && startDate.length === 10) {
                                page = 0
                                getUnionTransactionsList("", endDate)
                            } else if (startDate.length === 10 && date.length === 9) {
                                page = 0
                                getUnionTransactionsList("", endDate)
                            } else if (date.length === 10 && date !== startDate) {
                                page = 0
                                getUnionTransactionsList(date, endDate)
                            }

                            setStartDate(date)
                        }}
                    />
                    <TextField
                        className="w-100"
                        id="outlined-basic"
                        label="تاریخ پایان"
                        variant="outlined"
                        value={endDate}
                        onChange={e => {
                            let date = convertToBirthDate(e.target.value);
                            if (date.length === 0 && endDate.length === 10) {
                                page = 0
                                getUnionTransactionsList(startDate, "")
                            } else if (endDate.length === 10 && date.length === 9) {
                                page = 0
                                getUnionTransactionsList(startDate, "")
                            } else if (date.length === 10 && date !== endDate) {
                                page = 0
                                getUnionTransactionsList(startDate, date)
                            }

                            setEndDate(date)
                        }}
                    />
                </div>

                <div className={"d-flex flex-nowrap w-100 alignItemsCenter"}>
                    <span className={"flex-grow-1"}>سابقه تراکنشات</span>
                </div>

                <CustomTable
                    header={unionDetailTableHeader}
                    data={unionInfoList}
                    rowClicked={_ => {

                    }}
                    summation={transactionSummation}
                    title={"هیچ سابقه تراکنشی یافت نشد!"}
                />
                <Box className="paginationContainer">
                    {pageCount > 0 && <Pagination
                        count={pageCount}
                        color="primary"
                        onChange={handleChangePagination}
                        showFirstButton showLastButton/>}
                </Box>

            </div>
        </>

    )
}


export default UnionDetailPage

export const unionDetailTableHeader = [
    {
        id: 'number',
        label: '#',
        align: 'right',
    },
    {
        id: 'amount',
        label: 'مبلغ (ریال)',
        align: 'right',
    },
    {
        id: 'date',
        label: 'تاریخ واریز',
        align: 'right',
    },
]